var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var _a;
import { createAction, createReducer } from 'redux-act';
export var showSuspendedUserPopup = createAction('show suspended user popup');
export var showSuspendedUserPopupWithNotification = createAction('show suspended user popup with notifications');
export var hideSuspendedUserPopup = createAction('hide suspended user popup');
var initialState = {
    isVisible: 0,
};
export var suspendedUserReducer = createReducer((_a = {},
    _a[showSuspendedUserPopup.getType()] = function (state) { return (__assign(__assign({}, state), { isVisible: 1 })); },
    _a[showSuspendedUserPopupWithNotification.getType()] = function (state) { return (__assign(__assign({}, state), { isVisible: 2 })); },
    _a[hideSuspendedUserPopup.getType()] = function (state) { return (__assign(__assign({}, state), { isVisible: 0 })); },
    _a), initialState);
